export const googleMapsApiKey = 'AIzaSyAX8rtBujxApQiSvnrDvykPBzNYM32VEaM';